import * as utils from '../utils/utils.js';
import * as utilsFair from '../subpage_fairground/helpers/fairgroundStructure.js';

function fairTheme(sparkThemeConfig) {
  if (utils.validateEntireSubpageTheme(sparkThemeConfig[0].baseThemeClass)) {
    utils.applyThemeClass(sparkThemeConfig[0].baseThemeClass);
    utilsFair.createHeader(sparkThemeConfig);
    utilsFair.createFooter(sparkThemeConfig);

    $('link[href*="favicon"]').each(function () {
      $(this).attr(
        'href',
        `${CLIENTRESOURCEPATH}dist/images/fairgrounds/favicon.ico?sv=${SITEVERSION}`,
      );
    });
  }

  if (utils.validateLandingPage(sparkThemeConfig[0].landingThemeClass)) {
    utilsFair.createContent(sparkThemeConfig);

    $(globalThis).load(function () {
      $('#goog-gt-tt').remove();
    });
  }
}

export { fairTheme };
